import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Box, Chip, Grid, Stack, Typography } from '@mui/material';
import MainCard from '../../MainCard';
import { RiseOutlined, FallOutlined } from '@ant-design/icons';

const LeftMenuItems= ({ title, icons }) => (
    <MainCard contentSX={{ p: 2.25 }}>
        <Stack spacing={0.5}>
            <Box  style={{display: 'flex', justifyContent: 'space-between'}}>
                <Typography variant="h5" color="textPrimary">
                    {title}
                </Typography>
                {icons}
            </Box>
            {/* <Grid container alignItems="center">
                <Grid item>
                    <Typography variant="h4" color="inherit">
                        {count}
                    </Typography>
                </Grid>
                {percentage && (
                    <Grid item>
                        <Chip
                            variant="combined"
                            color={color}
                            icon={
                                <>
                                    {!isLoss && <RiseOutlined style={{ fontSize: '0.75rem', color: 'inherit' }} />}
                                    {isLoss && <FallOutlined style={{ fontSize: '0.75rem', color: 'inherit' }} />}
                                </>
                            }
                            label={`${percentage}%`}
                            sx={{ ml: 1.25, pl: 1 }}
                            size="small"
                        />
                    </Grid>
                )}
            </Grid> */}
        </Stack>
        {/* <Box sx={{ pt: 2.25 }}>
            <Typography variant="caption" color="textSecondary">
                You made an extra{' '}
                <Typography component="span" variant="caption" sx={{ color: `${color || 'primary'}.main` }}>
                    {extra}
                </Typography>{' '}
                this year
            </Typography>
        </Box> */}
    </MainCard>
);

LeftMenuItems.propTypes = {
    color: PropTypes.string,
    title: PropTypes.string,
    count: PropTypes.string,
    percentage: PropTypes.number,
    isLoss: PropTypes.bool,
    extra: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
};

// LeftMenuItems.defaultProps = {
//     color: 'primary'
// };

export default LeftMenuItems;
